const ContactInformationViewPage = () => {
  return <></>;
};

export default ContactInformationViewPage;
